import React from 'react';
import NotFoundComponent from '../../components/notFound/NotFoundComponent';

const NotFoundPage: React.FC = () => {
    return <NotFoundComponent />;
};

export default NotFoundPage;
